import {
  clearPostAuthRedirect,
  peekSanitizedPostAuthRedirect,
} from 'utils/postAuthRedirect';
import { sanitizeInternalRedirectPath } from 'utils/sanitizeInternalRedirectPath';

type Auth0AppState = {
  returnTo?: unknown;
  error?: string;
};

export function resolveAuth0PostLoginTarget(
  appState: Auth0AppState | undefined
): string {
  const returnToRaw =
    typeof appState?.returnTo === 'string' ? appState.returnTo : null;
  const fromState = sanitizeInternalRedirectPath(returnToRaw);
  const fromSession = peekSanitizedPostAuthRedirect();
  return fromState || fromSession || '/';
}

/**
 * After Auth0 exchanges the code, strip OAuth query params and land on the hash route.
 * Clears pending sessionStorage redirect (already reflected in target when needed).
 */
export function applyAuth0PostLoginNavigation(
  appState: Auth0AppState | undefined
): void {
  const target = resolveAuth0PostLoginTarget(appState);

  clearPostAuthRedirect();

  if (window.location.search) {
    window.history.replaceState(
      window.history.state,
      document.title,
      window.location.pathname
    );
  }

  window.location.hash = `#${target}`;
}
